import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './veiculoForm';
import Select from '../common/form/select';
import DateFormat from '../common/dateFormat/DateFormat';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import consts from '../consts';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Cookies from 'react-cookies';

import {
	setModoTela, initForm, salvar, excluir, getListaDashboard, getListaTipo, getLista as getListaVeiculo,
	getListaUnidade, getListaOperacao, getListaMotorista, getListaReboque, alterarConfiguracao,
	getListaEntradas, getListaSaidas, getListaTransferencias, getListaPosicaoVeiculo,
	imprimirDocumentacao, getListaDocumentoVeiculo, getListaDocumentoMotorista,
	baixarDocumentosVeiculo, baixarDocumentosMotorista
} from './veiculoActions';

class VeiculoDashboard extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: '',
		filtro: {
			ids_status: [],
			ids_unidades: []
		}
	}

	getStatus(status) {
		const statusConfig = {
			'Trânsito': {
				color: '#16a34a',
				bg: '#dcfce7',
				border: '#86efac',
				label: 'EM TRÂNSITO'
			},
			'Agendado': {
				color: '#2563eb',
				bg: '#dbeafe',
				border: '#93c5fd',
				label: 'AGENDADO'
			},
			'Manutenção': {
				color: '#dc2626',
				bg: '#fee2e2',
				border: '#fca5a5',
				label: 'MANUTENÇÃO'
			},
			'Disponível': {
				color: '#0891b2',
				bg: '#cffafe',
				border: '#67e8f9',
				label: 'DISPONÍVEL'
			}
		};

		return statusConfig[status] || {
			color: '#475569',
			bg: '#f1f5f9',
			border: '#cbd5e1',
			label: status || 'SEM STATUS'
		};
	}

	componentWillMount() {
		this.props.getListaUnidade();
		this.props.getListaOperacao();
		this.props.getListaMotorista();
		this.props.getListaVeiculo();
		this.props.getListaReboque();
		this.props.getListaDashboard();
		this.props.getListaEntradas();
		this.props.getListaSaidas();
		this.props.getListaTransferencias();
		this.props.getListaPosicaoVeiculo();
		this.props.getListaDocumentoVeiculo();
		this.props.getListaDocumentoMotorista();

		let idInterval = setInterval(() => {
			this.props.getListaUnidade();
			this.props.getListaOperacao();
			this.props.getListaMotorista();
			this.props.getListaVeiculo();
			this.props.getListaReboque();
			this.props.getListaDashboard();
			this.props.getListaEntradas();
			this.props.getListaSaidas();
			this.props.getListaTransferencias();
			this.props.getListaPosicaoVeiculo();
			this.props.getListaDocumentoVeiculo();
			this.props.getListaDocumentoMotorista();
		}, 30000);

		const cookieFiltro = Cookies.load('veiculoDashboardFiltro');

		this.setState({
			idInterval: idInterval,
			filtro: {
				...(cookieFiltro || {})
			}
		});
	}

	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}

	}

	render() {
		return (
			<div>
				<Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.lista()}
				</Content>
			</div>
		)
	}

	setFiltro(filtro) {

		Cookies.save('veiculoDashboardFiltro', JSON.stringify({
			...filtro
		}), { path: '/' });

		this.setState({
			filtro: {
				...filtro
			}
		});

	}

	lista() {

		if (!this.props.usuarioCarregado) {
			return null;
		}

		const lista = this.props.lista.filter(item => {
			if ((this.state.filtro.ids_status || []).length && !(this.state.filtro.ids_status || []).includes(item.status_placa)) {
				return false;
			}
			if ((this.state.filtro.ids_unidades || []).length && !(this.state.filtro.ids_unidades || []).includes(item.id_unidade_conf)) {
				return false;
			}
			if (this.state.id_operacao && item.id_operacao != this.state.id_operacao) {
				return false;
			}
			if (this.state.pesquisar
				&& !(`
					${this.getStatus(item.status_placa).label}
					${item.placa}
					${item.nome_motorista || 'SEM MOTORISTA'}
					${item.placa_carreta1}
					${item.placa_carreta2}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			if ((this.props.usuarioCarregado.ids_gestao_unidade || []).length
				&& item.id_unidade_conf
				&& !(this.props.usuarioCarregado.ids_gestao_unidade || []).includes(item.id_unidade_conf)) {
				return false;
			}
			if ((this.props.usuarioCarregado.ids_gestao_veiculo_operacao || []).length
				&& item.id_operacao
				&& !(this.props.usuarioCarregado.ids_gestao_veiculo_operacao || []).includes(item.id_operacao)) {
				return false;
			}

			return true;
		});

		const listaStatus = [
			{ id: 'Trânsito', valor: 'Trânsito' },
			{ id: 'Agendado', valor: 'Agendado' },
			{ id: 'Manutenção', valor: 'Manutenção' },
			{ id: 'Disponível', valor: 'Disponível' }
		];

		return (
			<>
				<ContentCard>

					{this.modalDetalhes()}

					<ContentCardHeader>
						<Row>
							<Select
								options={listaStatus}
								label='Status'
								cols='12 6 3 2'
								placeholder='Selecione'
								multiple={true}
								value={listaStatus.filter(status => {
									return (this.state.filtro.ids_status || []).includes(status.id);
								}).map(item => ({ value: item.id, label: item.valor }))}
								onChange={values => {
									this.setFiltro({ ...this.state.filtro, ids_status: (values || []).map(item => item.value) })
								}} />

							<Select
								options={this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA'))}
								label='Unidade'
								cols='12 6 4 3'
								placeholder='Selecione'
								multiple={true}
								value={this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA')).filter(unidade => {
									return (this.state.filtro.ids_unidades || []).includes(unidade.id);
								}).map(item => ({ value: item.id, label: item.valor }))}
								onChange={values => {
									this.setFiltro({ ...this.state.filtro, ids_unidades: (values || []).map(item => item.value) })
								}} />

							<Select
								options={this.props.listaOperacao.filter(item => {
									return !(this.props.usuarioCarregado.ids_gestao_veiculo_operacao || []).length
										|| (this.props.usuarioCarregado.ids_gestao_veiculo_operacao || []).includes(item.id);
								})}
								label='Operação'
								cols='12 6 4 3'
								placeholder='Selecione a operacao'
								value={this.state.id_operacao}
								onChange={value => this.setState({
									...this.state,
									id_operacao: value
								})} />

							<Grid cols='12 12 4 3'>
								<label>Pesquisar</label>
								<input className='form-control'
									placeholder='Pesquisar'
									type='text'
									value={this.state.pesquisar}
									onChange={e => {
										this.setState({ ...this.state, pesquisar: e.target.value });
									}} />
							</Grid>

							<a class='btn btn-app bg-secondary' style={{ marginTop: 8 }}
								onClick={() => this.setState({ modoTela: this.state.modoTela == 'expandido' ? 'compacto' : 'expandido' })}>
								<i class={this.state.modoTela == 'expandido' ? 'fas fa-compress' : 'fas fa-expand'}></i> {this.state.modoTela == 'expandido' ? 'Compacto' : 'Expandido'}
							</a>
							
						</Row>
					</ContentCardHeader>
				</ContentCard>

				<Row alignCenter>
					{lista.map(item => {
						return this.state.modoTela == 'expandido' ? this.componentCard(item) : this.componentCardResumo(item);
					})}
				</Row>
			</>
		);
	}

	componentCardResumo(registro) {
		const viagemAtual = (registro.itens || [])[0] || null;

		

		const currentStatus = this.getStatus(registro.status_placa);

		const percentual = viagemAtual && viagemAtual.percentual != null
			? (viagemAtual.percentual > 100 ? 100 : viagemAtual.percentual)
			: null;

		const emOperacao = registro.status_placa === 'Trânsito';

		var carretas = [];
		if (registro.placa_carreta1) {
			carretas.push(registro.placa_carreta1);
		}
		if (registro.placa_carreta2) {
			carretas.push(registro.placa_carreta2);
		}

		const carretasTexto = carretas.join(' / ');

		const tipoOperacao = emOperacao && viagemAtual && viagemAtual.tipo
			? viagemAtual.tipo.toUpperCase()
			: '';

		return (
			<Grid cols='12 6 4 3' key={registro.id} style={{ minWidth: 300 }}>
				<div
					onClick={this.setDialogDetalhes.bind(this, registro)}
					style={{
						background: '#ffffff',
						border: '1px solid ' + currentStatus.border,
						borderLeft: '5px solid ' + currentStatus.color,
						borderRadius: 14,
						padding: 10,
						marginBottom: 8,
						minHeight: 110,
						boxShadow: '0 4px 12px rgba(15, 23, 42, 0.06)',
						cursor: 'pointer'
					}}
				>
					<div
						style={{
							display: 'flex',
							alignItems: 'flex-start',
							justifyContent: 'space-between',
							gap: 8,
							marginBottom: 0
						}}
					>
						<div style={{ minWidth: 0, flex: 1 }}>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									flexWrap: 'wrap',
									gap: 6,
									marginBottom: 2
								}}
							>
								<div
									style={{
										fontSize: 18,
										fontWeight: '800',
										color: '#0f172a',
										letterSpacing: '.04em'
									}}
								>
									{registro.placa}
								</div>

								{carretasTexto ? (
									<div
										style={{
											fontSize: 10,
											fontWeight: '700',
											color: '#475569',
											background: '#f8fafc',
											border: '1px solid #e2e8f0',
											borderRadius: 999,
											padding: '2px 6px',
											whiteSpace: 'nowrap'
										}}
									>
										{carretasTexto}
									</div>
								) : null}
							</div>
						</div>

						<div
							style={{
								fontSize: 10,
								fontWeight: '800',
								color: currentStatus.color,
								background: currentStatus.bg,
								border: '1px solid ' + currentStatus.border,
								borderRadius: 999,
								padding: '4px 8px',
								whiteSpace: 'nowrap'
							}}
						>
							{currentStatus.label}
						</div>

						<button
							onClick={() => this.setDialogDetalhes(registro)}
							title='Detalhes'
							style={{
								width: 34,
								height: 34,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: '#ffffff',
								color: '#334155',
								border: '1px solid #dbe2ea',
								borderRadius: 10,
								cursor: 'pointer',
								marginTop: -6
							}}
						>
							<i className='fas fa-ellipsis-h'></i>
						</button>
					</div>

					<div
						style={{
							fontSize: 11,
							fontWeight: '700',
							color: '#334155',
							lineHeight: '16px',
							marginBottom: 4,
							overflow: 'hidden',
							display: '-webkit-box',
							WebkitLineClamp: 2,
							WebkitBoxOrient: 'vertical',
							wordBreak: 'break-word'
						}}
						title={registro.nome_motorista || 'Sem motorista'}
					>
						{registro.nome_motorista || 'SEM MOTORISTA'}
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 8
						}}
					>
						<div
							style={{
								fontSize: 11,
								fontWeight: '700',
								color: emOperacao ? '#2563eb' : '#94a3b8',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis'
							}}
						>
							{emOperacao ? tipoOperacao : ''}
						</div>

						{emOperacao && percentual != null ? (
							<div
								style={{
									minWidth: 54,
									textAlign: 'right',
									fontSize: 14,
									fontWeight: '800',
									color: '#2563eb'
								}}
							>
								{percentual}%
							</div>
						) : (
							<div
								style={{
									minWidth: 54
								}}
							></div>
						)}
					</div>

					{emOperacao && percentual != null && (
						<div
							style={{
								marginTop: 8,
								height: 6,
								borderRadius: 999,
								background: '#e2e8f0',
								overflow: 'hidden'
							}}
						>
							<div
								style={{
									width: percentual + '%',
									height: '100%',
									borderRadius: 999,
									background: 'linear-gradient(90deg, #2563eb, #06b6d4)'
								}}
							/>
						</div>
					)}
				</div>
			</Grid>
		);
	}

	componentCard(registro) {
		const viagemAtual = (registro.itens || [])[0] || null;
		const agendadas = (registro.itens || []).filter(function (viagem, index) {
			return viagem && index > 0;
		});

		const posicao = (this.props.listaPosicaoVeiculo || []).filter(function (pos) {
			return pos.placa === registro.placa;
		})[0];

		const currentStatus = this.getStatus(registro.status_placa);

		const percentual = viagemAtual && viagemAtual.percentual != null
			? (viagemAtual.percentual > 100 ? 100 : viagemAtual.percentual)
			: 0;

		const hasLocation =
			registro.latitude &&
			registro.longitude &&
			posicao &&
			posicao.telemetria &&
			posicao.telemetria.localizacao;

		return (
			<Grid
				cols='12 6 4 3'
				key={registro.id}
				style={{ minWidth: 320 }}
			>
				<ContentCard
					style={{
						background: '#ffffff',
						border: '1px solid ' + currentStatus.border,
						borderRadius: 18,
						boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
						overflow: 'hidden'
					}}
				>
					<ContentCardHeader
						style={{
							padding: 14,
							borderBottom: '1px solid #e2e8f0',
							background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
						}}
					>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: 10,
								marginBottom: 12
							}}
						>
							<div
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									gap: 8,
									padding: '6px 12px',
									borderRadius: 999,
									background: currentStatus.bg,
									border: '1px solid ' + currentStatus.border,
									color: currentStatus.color,
									fontSize: 10,
									fontWeight: '800',
									letterSpacing: '.06em'
								}}
							>
								<div
									style={{
										width: 8,
										height: 8,
										borderRadius: '50%',
										backgroundColor: currentStatus.color
									}}
								/>
								{currentStatus.label}
							</div>

							<button
								onClick={() => this.setDialogDetalhes(registro)}
								title='Detalhes'
								style={{
									width: 34,
									height: 34,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									background: '#ffffff',
									color: '#334155',
									border: '1px solid #dbe2ea',
									borderRadius: 10,
									cursor: 'pointer'
								}}
							>
								<i className='fas fa-ellipsis-h'></i>
							</button>
						</div>

						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: 8,
								marginBottom: 10
							}}
						>
							<div>
								<div
									style={{
										fontSize: 22,
										fontWeight: '800',
										color: '#0f172a',
										letterSpacing: '.04em'
									}}
								>
									{registro.placa}
								</div>
							</div>

							<div
								style={{
									padding: '8px 10px',
									borderRadius: 12,
									background: '#f8fafc',
									border: '1px solid #e2e8f0',
									minWidth: 92,
									textAlign: 'center'
								}}
							>
								<div style={{ fontSize: 12, fontWeight: '700', color: '#0f172a' }}>
									FROTA
								</div>
							</div>
						</div>

						<div
							style={{
								display: 'grid',
								gridTemplateColumns: 'minmax(0, 1fr) 78px 78px',
								gap: 8,
								marginBottom: 12,
								alignItems: 'stretch'
							}}
						>
							<div
								style={{
									background: '#f8fafc',
									border: '1px solid #e2e8f0',
									borderRadius: 12,
									padding: '10px 12px',
									minWidth: 0
								}}
								title={registro.nome_motorista || 'Sem motorista'}
							>
								<div style={{ fontSize: 10, color: '#64748b', marginBottom: 4 }}>
									Motorista
								</div>
								<div
									style={{
										fontSize: 12,
										fontWeight: '700',
										color: '#0f172a',
										lineHeight: '16px',
										whiteSpace: 'normal',
										wordBreak: 'break-word',
										overflowWrap: 'break-word'
									}}
								>
									{registro.nome_motorista || 'SEM MOTORISTA'}
								</div>
							</div>

							<div
								style={{
									background: '#f8fafc',
									border: '1px solid #e2e8f0',
									borderRadius: 12,
									padding: '10px 8px',
									textAlign: 'center',
									width: 78
								}}
							>
								<div style={{ fontSize: 10, color: '#64748b', marginBottom: 4 }}>
									Carreta 1
								</div>
								<div
									style={{
										fontSize: 12,
										fontWeight: '700',
										color: '#0f172a',
										whiteSpace: 'nowrap'
									}}
								>
									{registro.placa_carreta1 || '-'}
								</div>
							</div>

							<div
								style={{
									background: '#f8fafc',
									border: '1px solid #e2e8f0',
									borderRadius: 12,
									padding: '10px 8px',
									textAlign: 'center',
									width: 78
								}}
							>
								<div style={{ fontSize: 10, color: '#64748b', marginBottom: 4 }}>
									Carreta 2
								</div>
								<div
									style={{
										fontSize: 12,
										fontWeight: '700',
										color: '#0f172a',
										whiteSpace: 'nowrap'
									}}
								>
									{registro.placa_carreta2 || '-'}
								</div>
							</div>
						</div>


						<div
							style={{
								background: '#f8fafc',
								border: '1px solid #e2e8f0',
								borderRadius: 12,
								padding: '10px 12px'
							}}
						>
							<div style={{ fontSize: 10, color: '#64748b', marginBottom: 4 }}>
								Localização atual
							</div>

							{hasLocation ? (
								<a
									href={'https://www.google.com/maps/place/' + registro.latitude + ',' + registro.longitude}
									target='_blank'
									rel='noopener noreferrer'
									style={{
										display: 'block',
										fontSize: 12,
										fontWeight: '700',
										color: '#0ea5e9',
										textDecoration: 'none',
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis'
									}}
									title={posicao.telemetria.localizacao}
								>
									{posicao.telemetria.localizacao}
								</a>
							) : (
								<div
									style={{
										fontSize: 12,
										fontWeight: '600',
										color: '#64748b'
									}}
								>
									Sem rastreamento
								</div>
							)}
						</div>
					</ContentCardHeader>

					<ContentCardBody style={{ padding: 14, background: '#ffffff' }}>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								gap: 12,
								maxHeight: 320,
								overflowY: 'auto'
							}}
						>
							{viagemAtual && (
								<div
									style={{
										background: '#f8fafc',
										border: '1px solid #dbeafe',
										borderRadius: 16,
										padding: 12
									}}
								>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
											marginBottom: 10
										}}
									>
										<div style={{ fontSize: 11, color: '#2563eb', fontWeight: '800' }}>
											OPERAÇÃO ATUAL
										</div>
										<div style={{ fontSize: 11, color: '#334155', fontWeight: '700' }}>
											{(viagemAtual && viagemAtual.codigo) || 'Sem número'}
										</div>
									</div>

									<div style={{ marginBottom: 6 }}>
										<div
											style={{
												display: 'flex',
												justifyContent: 'space-between',
												marginBottom: 6
											}}
										>
											<span style={{ fontSize: 10, color: '#64748b' }}>{(viagemAtual && viagemAtual.tipo) || 'Sem tipo'}</span>
											<span style={{ fontSize: 10, color: '#0f172a', fontWeight: '700' }}>
												{percentual}%
											</span>
										</div>

										<div
											style={{
												height: 10,
												borderRadius: 999,
												background: '#e2e8f0',
												overflow: 'hidden'
											}}
										>
											<div
												style={{
													width: percentual + '%',
													height: '100%',
													borderRadius: 999,
													background: 'linear-gradient(90deg, #2563eb, #06b6d4)'
												}}
											/>
										</div>
									</div>
								</div>
							)}

							{agendadas.length > 0 && (
								<div
									style={{
										background: '#f8fafc',
										border: '1px solid #dbeafe',
										borderRadius: 16,
										padding: 12
									}}
								>
									<div
										style={{
											fontSize: 11,
											color: '#2563eb',
											fontWeight: '800',
											marginBottom: 10
										}}
									>
										PRÓXIMAS VIAGENS
									</div>

									<div
										style={{
											display: 'grid',
											gridTemplateColumns: '1fr .8fr 1.2fr',
											gap: 8,
											paddingBottom: 8,
											borderBottom: '1px solid #e2e8f0',
											marginBottom: 8
										}}
									>
										<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700' }}>Tipo</div>
										<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700', textAlign: 'center' }}>
											Número
										</div>
										<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700', textAlign: 'right' }}>
											Data/Hora
										</div>
									</div>

									{agendadas.map(function (agendada) {
										return (
											<div
												key={agendada.giro}
												style={{
													display: 'grid',
													gridTemplateColumns: '1fr .8fr 1.2fr',
													gap: 8,
													padding: '8px 0',
													borderBottom: '1px solid #e2e8f0'
												}}
											>
												<div style={{ fontSize: 11, color: '#0f172a' }}>
													{agendada.tipo}
												</div>
												<div style={{ fontSize: 11, color: '#475569', textAlign: 'center' }}>
													{agendada.codigo}
												</div>
												<div style={{ fontSize: 11, color: '#475569', textAlign: 'right' }}>
													{DateFormat.formatarDataHoraSqlParaTela(agendada.datahora)}
												</div>
											</div>
										);
									})}
								</div>
							)}

							{((registro.manutencao_agendada && registro.manutencao_agendada[0]) ||
								(registro.manutencao_aberta && registro.manutencao_aberta[0])) && (
									<div
										style={{
											background: '#fffafa',
											border: '1px solid #fecaca',
											borderRadius: 16,
											padding: 12
										}}
									>
										<div
											style={{
												fontSize: 11,
												color: '#dc2626',
												fontWeight: '800',
												marginBottom: 10
											}}
										>
											MANUTENÇÕES
										</div>

										<div
											style={{
												display: 'grid',
												gridTemplateColumns: '1fr .8fr 1.2fr',
												gap: 8,
												paddingBottom: 8,
												borderBottom: '1px solid #fee2e2',
												marginBottom: 8
											}}
										>
											<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700' }}>Tipo</div>
											<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700', textAlign: 'center' }}>
												Status
											</div>
											<div style={{ fontSize: 10, color: '#64748b', fontWeight: '700', textAlign: 'right' }}>
												Data/Hora
											</div>
										</div>

										{registro.manutencao_aberta && registro.manutencao_aberta[0] && (
											<div
												style={{
													display: 'grid',
													gridTemplateColumns: '1fr .8fr 1.2fr',
													gap: 8,
													padding: '8px 0',
													borderBottom: '1px solid #fee2e2'
												}}
											>
												<div style={{ fontSize: 11, color: '#0f172a' }}>
													{registro.manutencao_aberta[0].nome_tipo}
												</div>
												<div
													style={{
														fontSize: 11,
														color: '#dc2626',
														textAlign: 'center',
														fontWeight: '700'
													}}
												>
													Executando
												</div>
												<div style={{ fontSize: 11, color: '#475569', textAlign: 'right' }}>
													{DateFormat.formatarDataHoraSqlParaTela(
														registro.manutencao_aberta[0].datahora_previsao
													)}
												</div>
											</div>
										)}

										{registro.manutencao_agendada && registro.manutencao_agendada[0] && (
											<div
												style={{
													display: 'grid',
													gridTemplateColumns: '1fr .8fr 1.2fr',
													gap: 8,
													padding: '8px 0'
												}}
											>
												<div style={{ fontSize: 11, color: '#0f172a' }}>
													{registro.manutencao_agendada[0].nome_tipo}
												</div>
												<div
													style={{
														fontSize: 11,
														color: '#b91c1c',
														textAlign: 'center',
														fontWeight: '700'
													}}
												>
													Agendada
												</div>
												<div style={{ fontSize: 11, color: '#475569', textAlign: 'right' }}>
													{DateFormat.formatarDataHoraSqlParaTela(
														registro.manutencao_agendada[0].datahora
													) || 'Sem Data'}
												</div>
											</div>
										)}
									</div>
								)}
						</div>
					</ContentCardBody>
				</ContentCard>
			</Grid>
		);
	}


	setDialogDetalhes(registro) {
		this.setState({
			...this.state,
			registroDetalhes: registro
		});
	}

	modalDetalhes() {

	const registro = this.state.registroDetalhes ? {
		...this.props.lista.filter(item => item.id == this.state.registroDetalhes.id)[0]
	} : null;

	if (!registro) {
		return null;
	}

	let transitos = (registro.itens || []).filter(viagem => viagem && viagem.status == 'TRANSITO').filter((item, i) => i == 0);
	let agendadas = (registro.itens || []).filter(viagem => viagem && viagem.status == 'AGENDADA');
	let posicao = this.props.listaPosicaoVeiculo.filter(posicao => posicao.placa == registro.placa)[0];

	const veiculo = this.props.listaVeiculo.filter(opt => opt.id == registro.id_veiculo_conf)[0];
	let compartimentos = (veiculo ? veiculo.compartimentos || [] : []).map((compartimento, i) => ({
		id: i + 1,
		valor: `Compartimento ${i + 1}`,
		capacidade: parseFloat(compartimento),
		tamanho: veiculo.capacidade ? `${parseInt((compartimento * 100) / parseInt(veiculo.capacidade))}%` : 100
	}));

	return (
		<div class='modal fade show' id='modal-xl' style={{ display: 'block', backgroundColor: 'rgba(15, 23, 42, 0.35)' }} aria-modal='true'>
			<div class='modal-dialog modal-xl' style={{ maxWidth: '92vw' }}>
				<div
					class='modal-content'
					style={{
						borderRadius: 20,
						border: '1px solid #dbe2ea',
						boxShadow: '0 20px 50px rgba(15, 23, 42, 0.18)',
						overflow: 'hidden',
						background: '#f8fafc'
					}}
				>
					<div
						class='modal-header'
						style={{
							background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
							borderBottom: '1px solid #e2e8f0',
							padding: '16px 20px'
						}}
					>
						<div>
							<div
								style={{
									fontSize: 11,
									color: '#64748b',
									textTransform: 'uppercase',
									letterSpacing: '.08em',
									marginBottom: 2
								}}
							>
								Detalhes do veículo
							</div>
							<h4
								class='modal-title'
								style={{
									margin: 0,
									fontSize: 24,
									fontWeight: '800',
									color: '#0f172a'
								}}
							>
								{registro.placa}
							</h4>
						</div>

						<button
							type='button'
							class='close'
							data-dismiss='modal'
							aria-label='Close'
							onClick={() => this.setDialogDetalhes(null, null)}
							style={{
								width: 38,
								height: 38,
								borderRadius: 10,
								border: '1px solid #dbe2ea',
								background: '#ffffff',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								opacity: 1,
								color: '#334155'
							}}
						>
							<span aria-hidden='true'>×</span>
						</button>
					</div>

					<div
						class='modal-body'
						style={{
							maxHeight: window.innerHeight * 0.8,
							overflowY: 'auto',
							marginBottom: 0,
							padding: 16,
							background: '#f8fafc'
						}}
					>

						{/* CONJUNTO */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								border: '1px solid #dbe2ea',
								borderRadius: 16,
								background: '#ffffff',
								boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
								marginBottom: 12,
								overflow: 'hidden'
							}}
						>
							<label
								style={{
									fontSize: 14,
									textAlign: 'center',
									color: '#0f172a',
									fontWeight: '800',
									borderBottom: '1px solid #e2e8f0',
									padding: 10,
									margin: 0,
									background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
								}}
							>
								Alocação
							</label>

							<Row style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 6, paddingBottom: 6 }}>
								{this.props.listaUnidade.length > 0 &&
									<Select
										label='Base de Alocação'
										cols='12 12 12 12'
										value={registro.id_unidade_conf}
										onChange={value => {
											this.props.alterarConfiguracao({
												...registro,
												id_unidade_conf: value
											});
										}}
										options={(this.props.listaUnidade || [])} />}

								{(!registro.terceiro && this.props.listaMotorista.length > 0) &&
									<Select
										label='Motorista'
										cols='12 12 6 6'
										value={registro.id_motorista_conf}
										onChange={value => {
											this.props.alterarConfiguracao({
												...registro,
												id_motorista_conf: value
											});
										}}
										options={(this.props.listaMotorista || [])} />}

								{(!registro.terceiro && this.props.listaReboque.length > 0) &&
									<Select
										label='Reboque 1'
										cols='12 6 3 3'
										value={registro.id_carreta1_conf}
										onChange={value => {
											this.props.alterarConfiguracao({
												...registro,
												id_carreta1_conf: value
											});
										}}
										options={(this.props.listaReboque || [])} />}

								{(!registro.terceiro && this.props.listaReboque.length > 0) &&
									<Select
										label='Reboque 2'
										cols='12 6 3 3'
										value={registro.id_carreta2_conf}
										onChange={value => {
											this.props.alterarConfiguracao({
												...registro,
												id_carreta2_conf: value
											});
										}}
										options={(this.props.listaReboque || [])} />}
							</Row>

							{(registro && registro.nome_motorista) &&
								<Row style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 6, paddingBottom: 6 }}>
									<LabelAndInputMask
										label='CPF'
										cols='12 4 4 4'
										value={registro.cpf_motorista}
										readOnly='readOnly'
										onChange={value => { }}
										mask='999.999.999-99' />

									<LabelAndInput
										label='RG'
										cols='12 4 4 4'
										value={registro.rg_motorista}
										readOnly='readOnly'
										onChange={value => { }} />

									<LabelAndInput
										label='Órgão Expedidor'
										cols='12 4 4 4'
										value={registro.orgao_expedidor_motorista}
										readOnly='readOnly'
										onChange={value => { }} />
								</Row>}

							{(compartimentos && compartimentos.length > 0) &&
								<Row style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 6, paddingBottom: 6 }}>
									<Grid cols='12 12 12 12'>
										<div style={{ display: 'flex', flexDirection: 'row' }}>
											{compartimentos.map((compartimento, i) => {
												return (
													<div
														key={compartimento.id}
														style={{
															width: compartimento.tamanho,
															margin: 2,
															textAlign: 'center',
															fontWeight: '800',
															color: '#334155',
															fontSize: 12
														}}
													>
														{i + 1} - {FormatUtils.formatarValorTelaDecimal(compartimento.capacidade, 0)} L
													</div>
												);
											})}
										</div>

										<div style={{ display: 'flex', flexDirection: 'row' }}>
											{compartimentos.map(compartimento => {

												return (
													<div
														key={compartimento.id}
														style={{
															background: 'linear-gradient(180deg, #e2e8f0 0%, #cbd5e1 100%)',
															height: 88,
															width: compartimento.tamanho,
															margin: 2,
															display: 'flex',
															flexDirection: 'row',
															alignItems: 'end',
															borderRadius: 10,
															border: '1px solid #cbd5e1',
															boxShadow: 'inset 0 1px 2px rgba(255,255,255,.5)'
														}}
													>
													</div>
												);
											})}
										</div>

										<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingLeft: 5, paddingRight: 5, marginBottom: 8, marginTop: 8, color: '#475569' }}>
											<div>Dianteira</div>
											<div style={{ fontWeight: '800', color: '#0f172a' }}>
												Capacidade de {FormatUtils.formatarValorTelaDecimal(veiculo ? veiculo.capacidade : 0, 0)} L
											</div>
											<div>Traseira</div>
										</div>
									</Grid>
								</Row>}
						</div>

						{/* Trânsito */}
						{(transitos.length > 0) &&
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									border: '1px solid #86efac',
									borderRadius: 16,
									background: '#ffffff',
									boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
									overflow: 'hidden',
									marginBottom: 12
								}}
							>
								<label
									style={{
										fontSize: 14,
										textAlign: 'center',
										color: '#15803d',
										fontWeight: '800',
										borderBottom: '1px solid #bbf7d0',
										padding: 10,
										margin: 0,
										background: '#f0fdf4'
									}}
								>
									Viagem Atual
								</label>

								<table
									class='table table-valign-middle'
									style={{
										marginBottom: 0,
										background: '#ffffff'
									}}
								>
									<thead>
										<tr>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Tipo</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Cliente</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Produto</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Quantidade</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Status</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Previsto</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Realizado</th>
										</tr>
									</thead>
									<tbody>
										{(transitos || []).map(transito => {
											const produtos = (transito.produtos || []);

											return (
												<>
													{produtos.map((produto, i) => (
														<tr key={`${transito.id}-${i}`}>
															{i == 0 &&
																<td rowspan={produtos.length} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{transito.tipo}</td>}
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.id} {produto.nome_cliente}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.nome_produto}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.quantidade}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
																{transito.tipo == 'Entrega' ? (produto.tracking_datahora_chegada ? 'Entregue' : 'Trânsito') : (produto.status_frete || transito.status)}
															</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
																{DateFormat.formatarDataHoraSqlParaTela(transito.tipo == 'Entrega' ? produto.datahora_previsao_entrega : produto.datahora_previsao_chegada)}
															</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
																{DateFormat.formatarDataHoraSqlParaTela(transito.tipo == 'Entrega' ? produto.tracking_datahora_chegada : produto.datahora_chegada)}
															</td>
														</tr>
													))}
												</>
											);
										})}
									</tbody>
								</table>
							</div>}

						{/* Agendadas */}
						{(agendadas.length > 0) &&
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									border: '1px solid #93c5fd',
									borderRadius: 16,
									background: '#ffffff',
									boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
									overflow: 'hidden',
									marginBottom: 12
								}}
							>
								<label
									style={{
										fontSize: 14,
										textAlign: 'center',
										color: '#2563eb',
										fontWeight: '800',
										borderBottom: '1px solid #bfdbfe',
										padding: 10,
										margin: 0,
										background: '#eff6ff'
									}}
								>
									Próximas Viagens
								</label>

								<table
									class='table table-valign-middle'
									style={{
										marginBottom: 0,
										background: '#ffffff'
									}}
								>
									<thead>
										<tr>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Tipo</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Motorista</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Cliente</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Produto</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Quantidade</th>
											<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Status</th>
										</tr>
									</thead>
									<tbody>
										{(agendadas || []).map(agendada => {
											const produtos = (agendada.produtos || []);

											return (
												<>
													{produtos.map((produto, i) => (
														<tr key={`${agendada.id}-${i}`}>
															{i == 0 &&
																<td rowspan={produtos.length} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{agendada.tipo}</td>}
															{i == 0 &&
																<td rowspan={produtos.length} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{agendada.nome_motorista || 'Sem Motorista'}</td>}
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.nome_cliente}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.nome_produto}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{produto.quantidade}</td>
															<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
																{produto.tipo == 'Venda' ? (produto.datahora_chegada ? 'Entregue' : 'Trânsito') : agendada.status}
															</td>
														</tr>
													))}
												</>
											);
										})}
									</tbody>
								</table>
							</div>}

						{/* Manutenções */}
						{((registro.manutencao_agendada && registro.manutencao_agendada[0]) || (registro.manutencao_aberta && registro.manutencao_aberta[0])) &&
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									justifyContent: 'center',
									marginTop: 12,
									marginBottom: 12,
									border: '1px solid #fecaca',
									borderRadius: 16,
									background: '#ffffff',
									boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
									overflow: 'hidden'
								}}
							>
								<label
									style={{
										fontSize: 14,
										textAlign: 'center',
										color: '#dc2626',
										fontWeight: '800',
										borderBottom: '1px solid #fecaca',
										padding: 10,
										margin: 0,
										background: '#fef2f2'
									}}
								>
									Manutenções
								</label>

								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										justifyContent: 'space-between',
										borderBottom: '1px solid #fee2e2',
										padding: '10px 12px',
										background: '#fff5f5'
									}}
								>
									<div style={{ width: '30%', textAlign: 'left', fontWeight: '800', fontSize: 12, color: '#475569' }}>
										Tipo
									</div>
									<div style={{ width: '20%', textAlign: 'center', fontWeight: '800', fontSize: 12, color: '#475569' }}>
										Status
									</div>
									<div style={{ width: '50%', textAlign: 'right', fontWeight: '800', fontSize: 12, color: '#475569' }}>
										Data/Hora
									</div>
								</div>

								{(registro.manutencao_aberta && registro.manutencao_aberta[0]) &&
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											borderBottom: '1px solid #fee2e2',
											padding: '10px 12px',
											background: '#ffffff'
										}}
									>
										<div style={{ width: '30%', textAlign: 'left', fontSize: 12, color: '#0f172a' }}>
											{registro.manutencao_aberta[0].nome_tipo}
										</div>
										<div style={{ width: '20%', textAlign: 'center', fontSize: 12, color: '#dc2626', fontWeight: '700' }}>
											Executando
										</div>
										<div style={{ width: '50%', textAlign: 'right', fontSize: 12, color: '#0f172a' }}>
											{DateFormat.formatarDataHoraSqlParaTela(registro.manutencao_aberta[0].datahora_previsao)}
										</div>
									</div>}

								{(registro.manutencao_agendada && registro.manutencao_agendada[0]) &&
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											borderBottom: '1px solid #fee2e2',
											padding: '10px 12px',
											background: '#ffffff'
										}}
									>
										<div style={{ width: '30%', textAlign: 'left', fontSize: 12, color: '#0f172a' }}>
											{registro.manutencao_agendada[0].nome_tipo}
										</div>
										<div style={{ width: '20%', textAlign: 'center', fontSize: 12, color: '#b91c1c', fontWeight: '700' }}>
											Agendada
										</div>
										<div style={{ width: '50%', textAlign: 'right', fontSize: 12, color: '#0f172a' }}>
											{DateFormat.formatarDataHoraSqlParaTela(registro.manutencao_agendada[0].datahora) || 'Sem Data'}
										</div>
									</div>}
							</div>}

						{/* DOCUMENTOS DO VEÍCULO */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								border: '1px solid #dbe2ea',
								borderRadius: 16,
								background: '#ffffff',
								boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
								marginBottom: 12,
								marginTop: 12,
								overflow: 'hidden'
							}}
						>
							<label
								style={{
									fontSize: 14,
									textAlign: 'center',
									color: '#0f172a',
									fontWeight: '800',
									borderBottom: '1px solid #e2e8f0',
									padding: 10,
									margin: 0,
									background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
								}}
							>
								Documentos do Veículo

								<ButtonTable
									type={'primary'}
									icon={'fas fa-file-download'}
									visible={this.props.listaDocumentoVeiculo.filter(documento =>
										documento.id_veiculo == registro.id_veiculo_conf
										&& (documento.arquivos || []).length
									).length}
									small
									event={() => {
										this.props.baixarDocumentosVeiculo(this.props.listaDocumentoVeiculo.filter(documento =>
											documento.id_veiculo == registro.id_veiculo_conf
											&& (documento.arquivos || []).length
										));
									}} />
							</label>

							<table
								class='table table-valign-middle'
								style={{
									marginBottom: 0,
									background: '#ffffff'
								}}
							>
								<thead>
									<tr>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Placa</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Tipo</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Documento</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Número</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Vencimento</th>
										<th width={10} style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}></th>
									</tr>
								</thead>
								<tbody>
									{veiculo &&
										<tr>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.placa}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>RENAVAM</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.renavam}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
										</tr>}

									{veiculo &&
										<tr>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.placa}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>CHASSI</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{veiculo.chassi}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
										</tr>}

									{this.props.listaDocumentoVeiculo.filter(documento => documento.id_veiculo == registro.id_veiculo_conf).map(documento => (
										<tr key={documento.id}>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.placa}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo_veiculo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.numero}</td>
											<td
												style={{
													textAlign: 'center',
													fontSize: 12,
													verticalAlign: 'middle',
													color: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ffffff' : '#0f172a',
													backgroundColor: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ef4444' : null,
													fontWeight: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '700' : null
												}}
											>
												{DateFormat.formatarDataSqlParaTela(documento.data_vencimento)}
											</td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-file-download'}
													visible={(documento.arquivos || []).length}
													small
													event={() => {
														(documento.arquivos || []).map(arquivo => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														});
													}} />
											</td>
										</tr>
									))}

									{this.props.listaDocumentoVeiculo.filter(documento => documento.id_veiculo == registro.id_carreta1_conf).map(documento => (
										<tr key={documento.id}>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.placa}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo_veiculo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.numero}</td>
											<td
												style={{
													textAlign: 'center',
													fontSize: 12,
													verticalAlign: 'middle',
													color: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ffffff' : '#0f172a',
													backgroundColor: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ef4444' : null,
													fontWeight: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '700' : null
												}}
											>
												{DateFormat.formatarDataSqlParaTela(documento.data_vencimento)}
											</td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-file-download'}
													visible={(documento.arquivos || []).length}
													small
													event={() => {
														(documento.arquivos || []).map(arquivo => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														});
													}} />
											</td>
										</tr>
									))}

									{this.props.listaDocumentoVeiculo.filter(documento => documento.id_veiculo == registro.id_carreta2_conf).map(documento => (
										<tr key={documento.id}>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.placa}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo_veiculo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.numero}</td>
											<td
												style={{
													textAlign: 'center',
													fontSize: 12,
													verticalAlign: 'middle',
													color: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ffffff' : '#0f172a',
													backgroundColor: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ef4444' : null,
													fontWeight: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '700' : null
												}}
											>
												{DateFormat.formatarDataSqlParaTela(documento.data_vencimento)}
											</td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-file-download'}
													visible={(documento.arquivos || []).length}
													small
													event={() => {
														(documento.arquivos || []).map(arquivo => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														});
													}} />
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

						{/* DOCUMENTOS DO MOTORISTA */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								border: '1px solid #dbe2ea',
								borderRadius: 16,
								background: '#ffffff',
								boxShadow: '0 4px 14px rgba(15, 23, 42, 0.05)',
								marginBottom: 12,
								overflow: 'hidden'
							}}
						>
							<label
								style={{
									fontSize: 14,
									textAlign: 'center',
									color: '#0f172a',
									fontWeight: '800',
									borderBottom: '1px solid #e2e8f0',
									padding: 10,
									margin: 0,
									background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)'
								}}
							>
								Documentos do Motorista

								<ButtonTable
									type={'primary'}
									icon={'fas fa-file-download'}
									visible={this.props.listaDocumentoMotorista.filter(documento =>
										documento.id_motorista == registro.id_motorista_conf
										&& (documento.arquivos || []).length
									).length}
									small
									event={() => {
										this.props.baixarDocumentosMotorista(this.props.listaDocumentoMotorista.filter(documento =>
											documento.id_motorista == registro.id_motorista_conf
											&& (documento.arquivos || []).length
										));
									}} />
							</label>

							<table
								class='table table-valign-middle'
								style={{
									marginBottom: 0,
									background: '#ffffff'
								}}
							>
								<thead>
									<tr>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Nome</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Documento</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Número</th>
										<th style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}>Vencimento</th>
										<th width={10} style={{ textAlign: 'center', fontSize: 11, fontWeight: '800', color: '#475569', background: '#f8fafc', borderTop: 'none', whiteSpace: 'nowrap' }}></th>
									</tr>
								</thead>
								<tbody>
									{registro.nome_motorista &&
										<tr>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{registro.nome_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>CPF</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{FormatUtils.formatarCPF(registro.cpf_motorista)}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
										</tr>}

									{registro.nome_motorista &&
										<tr>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{registro.nome_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>RG</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{registro.rg_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
										</tr>}

									{registro.nome_motorista &&
										<tr>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{registro.nome_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>Órgão Expedidor</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{registro.orgao_expedidor_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}></td>
										</tr>}

									{this.props.listaDocumentoMotorista.filter(documento => documento.id_motorista == registro.id_motorista_conf).map(documento => (
										<tr key={documento.id}>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_motorista}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.nome_tipo}</td>
											<td style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>{documento.numero}</td>
											<td
												style={{
													textAlign: 'center',
													fontSize: 12,
													verticalAlign: 'middle',
													color: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ffffff' : '#0f172a',
													backgroundColor: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '#ef4444' : null,
													fontWeight: documento.data_vencimento && new Date(documento.data_vencimento).getTime() < new Date(DateFormat.getDataAtual()).getTime() ? '700' : null
												}}
											>
												{DateFormat.formatarDataSqlParaTela(documento.data_vencimento)}
											</td>
											<td width={10} style={{ textAlign: 'center', fontSize: 12, color: '#0f172a', verticalAlign: 'middle' }}>
												<ButtonTable
													type={'primary'}
													icon={'fas fa-file-download'}
													visible={(documento.arquivos || []).length}
													small
													event={() => {
														(documento.arquivos || []).map(arquivo => {
															window.open(`${consts.URL}/${arquivo.arquivo}`, '_blank');
														});
													}} />
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>

					</div>
				</div>
			</div>
		</div>
	);
}


}

const mapStateToProps = state => ({
	sessao: state.auth.veiculo,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.veiculo.modoTela,
	aguardando: state.veiculo.aguardando,
	lista: state.veiculo.listaDashboard,
	listaEntrada: state.veiculo.listaEntrada,
	listaSaida: state.veiculo.listaSaida,
	listaTransferencia: state.veiculo.listaTransferencia,
	listaUnidade: state.veiculo.listaUnidade,
	listaOperacao: state.veiculo.listaOperacao,
	listaMotorista: state.veiculo.listaMotorista,
	listaReboque: state.veiculo.listaReboque,
	listaVeiculo: state.veiculo.lista,
	listaPosicaoVeiculo: state.veiculo.listaPosicaoVeiculo,
	listaDocumentoVeiculo: state.veiculo.listaDocumentoVeiculo,
	listaDocumentoMotorista: state.veiculo.listaDocumentoMotorista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getListaDashboard, getListaTipo, getListaVeiculo,
	getListaUnidade, getListaOperacao, getListaMotorista, getListaReboque, alterarConfiguracao,
	getListaEntradas, getListaSaidas, getListaTransferencias, getListaPosicaoVeiculo,
	imprimirDocumentacao, getListaDocumentoVeiculo, getListaDocumentoMotorista,
	baixarDocumentosVeiculo, baixarDocumentosMotorista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(VeiculoDashboard);
